// CMS data layer for pages.
// `cms.pages` schema: (id, organization_id, slug, title, body_md, status, created_at, updated_at)
// status: 'draft' | 'published' | 'archived'

import { supabase, isSupabaseConfigured } from "../supabase";

const SCHEMA = "cms";

function table() {
  if (!isSupabaseConfigured) throw new Error("Requires live Supabase");
  return supabase.schema(SCHEMA).from("pages");
}

export async function listPages({ search, status } = {}) {
  let q = table()
    .select("id, organization_id, slug, title, body_md, status, created_at, updated_at")
    .order("updated_at", { ascending: false });
  if (status) q = q.eq("status", status);
  if (search) q = q.or(`title.ilike.%${search}%,slug.ilike.%${search}%`);
  const { data, error } = await q;
  if (error) throw error;
  return data || [];
}

export async function getPage(id) {
  const { data, error } = await table()
    .select("id, organization_id, slug, title, body_md, status, created_at, updated_at")
    .eq("id", id)
    .maybeSingle();
  if (error) throw error;
  return data || null;
}

export async function getPageBySlug(slug) {
  const { data, error } = await table()
    .select("*")
    .eq("slug", slug)
    .maybeSingle();
  if (error) throw error;
  return data || null;
}

export async function createPage({ organizationId, slug, title, bodyMd, status }) {
  const { data, error } = await table()
    .insert({
      organization_id: organizationId,
      slug,
      title,
      body_md: bodyMd || null,
      status: status || "draft",
    })
    .select("*")
    .single();
  if (error) throw error;
  return data;
}

export async function updatePage(id, patch) {
  const { data, error } = await table()
    .update(patch)
    .eq("id", id)
    .select("*")
    .single();
  if (error) throw error;
  return data;
}

export async function deletePage(id) {
  const { data, error } = await table()
    .delete()
    .eq("id", id)
    .select("id");
  if (error) throw error;
  if (!data || data.length === 0) throw new Error("Could not delete page");
}

export const PAGE_STATUS_META = {
  draft:     { label: "Draft",     tone: "border-neutral-200 bg-neutral-100 text-neutral-600" },
  published: { label: "Published", tone: "border-primary/30 bg-primary/10 text-primary-hover" },
  archived:  { label: "Archived",  tone: "border-neutral-300 bg-neutral-200 text-neutral-500" },
};

export function slugify(input) {
  return (input || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .slice(0, 80);
}
